import { Outlet, createFileRoute } from '@tanstack/react-router'
import AmendBooking from '@/components/my-booking/NewAmendBooking'

export const Route = createFileRoute('/my-booking/$id/amend/view')({
  component: RouteComponent,
})

function RouteComponent() {
  const bookingId = Route.useParams({
    select: (s) => s.id,
  })
  return (
    <>
      <AmendBooking bookingId={bookingId} />
      <Outlet />
    </>
  )
}
